import { render, staticRenderFns } from "./select-capital-org.vue?vue&type=template&id=cb3b89be"
import script from "./select-capital-org.vue?vue&type=script&lang=js"
export * from "./select-capital-org.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports